// source: log_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var page_pb = require('./page_pb.js');
goog.object.extend(proto, page_pb);
goog.exportSymbol('proto.api.GetVehicleLocationHistoryByVehicleIdRequest', null, global);
goog.exportSymbol('proto.api.GetVehicleLocationHistoryByVehicleIdResponse', null, global);
goog.exportSymbol('proto.api.VehicleLocationHistoryItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.GetVehicleLocationHistoryByVehicleIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetVehicleLocationHistoryByVehicleIdRequest.displayName = 'proto.api.GetVehicleLocationHistoryByVehicleIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.VehicleLocationHistoryItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.api.VehicleLocationHistoryItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.VehicleLocationHistoryItem.displayName = 'proto.api.VehicleLocationHistoryItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.api.GetVehicleLocationHistoryByVehicleIdResponse.repeatedFields_, null);
};
goog.inherits(proto.api.GetVehicleLocationHistoryByVehicleIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.api.GetVehicleLocationHistoryByVehicleIdResponse.displayName = 'proto.api.GetVehicleLocationHistoryByVehicleIdResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetVehicleLocationHistoryByVehicleIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
dateAndTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
page: (f = msg.getPage()) && page_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetVehicleLocationHistoryByVehicleIdRequest;
  return proto.api.GetVehicleLocationHistoryByVehicleIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDateAndTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 5:
      var value = new page_pb.PageRequest;
      reader.readMessage(value,page_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetVehicleLocationHistoryByVehicleIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateAndTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      page_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 date_and_time = 2;
 * @return {number}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.getDateAndTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.setDateAndTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double latitude = 3;
 * @return {number}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double longitude = 4;
 * @return {number}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional PageRequest page = 5;
 * @return {?proto.api.PageRequest}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.getPage = function() {
  return /** @type{?proto.api.PageRequest} */ (
    jspb.Message.getWrapperField(this, page_pb.PageRequest, 5));
};


/**
 * @param {?proto.api.PageRequest|undefined} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} returns this
*/
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdRequest} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdRequest.prototype.hasPage = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.VehicleLocationHistoryItem.prototype.toObject = function(opt_includeInstance) {
  return proto.api.VehicleLocationHistoryItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.VehicleLocationHistoryItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.VehicleLocationHistoryItem.toObject = function(includeInstance, msg) {
  var f, obj = {
dateAndTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
vehicleId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.VehicleLocationHistoryItem}
 */
proto.api.VehicleLocationHistoryItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.VehicleLocationHistoryItem;
  return proto.api.VehicleLocationHistoryItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.VehicleLocationHistoryItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.VehicleLocationHistoryItem}
 */
proto.api.VehicleLocationHistoryItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDateAndTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.VehicleLocationHistoryItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.VehicleLocationHistoryItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.VehicleLocationHistoryItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.VehicleLocationHistoryItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateAndTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 date_and_time = 1;
 * @return {number}
 */
proto.api.VehicleLocationHistoryItem.prototype.getDateAndTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.api.VehicleLocationHistoryItem} returns this
 */
proto.api.VehicleLocationHistoryItem.prototype.setDateAndTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.api.VehicleLocationHistoryItem.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.VehicleLocationHistoryItem} returns this
 */
proto.api.VehicleLocationHistoryItem.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.api.VehicleLocationHistoryItem.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.api.VehicleLocationHistoryItem} returns this
 */
proto.api.VehicleLocationHistoryItem.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string vehicle_id = 4;
 * @return {string}
 */
proto.api.VehicleLocationHistoryItem.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.api.VehicleLocationHistoryItem} returns this
 */
proto.api.VehicleLocationHistoryItem.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.api.GetVehicleLocationHistoryByVehicleIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && page_pb.PageResponse.toObject(includeInstance, f),
vehicleLocationsList: jspb.Message.toObjectList(msg.getVehicleLocationsList(),
    proto.api.VehicleLocationHistoryItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.api.GetVehicleLocationHistoryByVehicleIdResponse;
  return proto.api.GetVehicleLocationHistoryByVehicleIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new page_pb.PageResponse;
      reader.readMessage(value,page_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = new proto.api.VehicleLocationHistoryItem;
      reader.readMessage(value,proto.api.VehicleLocationHistoryItem.deserializeBinaryFromReader);
      msg.addVehicleLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.api.GetVehicleLocationHistoryByVehicleIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      page_pb.PageResponse.serializeBinaryToWriter
    );
  }
  f = message.getVehicleLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.api.VehicleLocationHistoryItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional PageResponse page = 1;
 * @return {?proto.api.PageResponse}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.getPage = function() {
  return /** @type{?proto.api.PageResponse} */ (
    jspb.Message.getWrapperField(this, page_pb.PageResponse, 1));
};


/**
 * @param {?proto.api.PageResponse|undefined} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} returns this
*/
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated VehicleLocationHistoryItem vehicle_locations = 2;
 * @return {!Array<!proto.api.VehicleLocationHistoryItem>}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.getVehicleLocationsList = function() {
  return /** @type{!Array<!proto.api.VehicleLocationHistoryItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.api.VehicleLocationHistoryItem, 2));
};


/**
 * @param {!Array<!proto.api.VehicleLocationHistoryItem>} value
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} returns this
*/
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.setVehicleLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.api.VehicleLocationHistoryItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.api.VehicleLocationHistoryItem}
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.addVehicleLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.api.VehicleLocationHistoryItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.api.GetVehicleLocationHistoryByVehicleIdResponse} returns this
 */
proto.api.GetVehicleLocationHistoryByVehicleIdResponse.prototype.clearVehicleLocationsList = function() {
  return this.setVehicleLocationsList([]);
};


goog.object.extend(exports, proto.api);
